import { useEffect, useState } from "react";
import SectionHeader from "./SectionHeader";
import Reveal from "./Reveal";
import { ArrowUpRight } from "lucide-react";
import { base44 } from "@/api/base44Client";
import { Link } from "react-router-dom";

export default function BedBugGuide() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    const today = new Date().toISOString().slice(0, 10);
    base44.entities.BlogPost.list("-published_date", 120)
      .then((rows) => {
        if (!active) return;
        const visible = (rows || [])
          .filter((p) => p.status === "published")
          .filter((p) => !p.published_date || p.published_date <= today)
          .slice(0, 9);
        setPosts(visible);
        setLoading(false);
      })
      .catch(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  return (
    <section id="guide" className="border-b border-border bg-background px-5 py-24 lg:px-8 lg:py-32">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col justify-between gap-6 sm:flex-row sm:items-end">
          <SectionHeader kicker="The Bed Bug Guide" title="THE BED BUG GUIDE." subtitle="Clear, practical answers — written for people dealing with bed bugs, not at them." />
          <Link to="/guide" className="inline-flex shrink-0 items-center gap-1.5 text-sm font-semibold text-primary hover:text-accent">Browse all articles <ArrowUpRight className="h-4 w-4" /></Link>
        </div>
        {loading ? (
          <div className="mt-14 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="h-48 animate-pulse rounded-lg border border-border bg-muted/20" />
            ))}
          </div>
        ) : posts.length === 0 ? null : (
          <div className="mt-14 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
            {posts.map((p, i) => (
              <Reveal key={p.id} delay={(i % 3) * 0.05}>
                <Link to={`/guide/${p.slug}`} className="group flex h-full flex-col rounded-lg border border-border bg-muted/20 p-7 transition-colors hover:border-accent/40 hover:bg-muted/40">
                  <span className="font-heading text-xs font-bold uppercase tracking-[0.18em] text-accent">{p.published_date || "Guide"}</span>
                  <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-primary">{p.title}</h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-muted-foreground">{p.excerpt}</p>
                  <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-primary">Read <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" /></span>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}